import React from "react";

const NewServiceSidebar = ({ selected, onSelect }) => {
  const sections = [
    { id: "basic", label: "Basic details" },
    { id: "team", label: "Team members" },
    { id: "resources", label: "Resources" },
    { id: "addons", label: "Service add-ons", badge: "New" },
  ];

  const settings = [
    { id: "online", label: "Online booking" },
    { id: "forms", label: "Forms", badge: "1" },
    { id: "commissions", label: "Commissions" },
    { id: "settings", label: "Settings" },
  ];

  return (
    <aside className="hidden md:block w-64 bg-dry text-text rounded-lg p-4">
      <h3 className="text-sm font-semibold mb-4 text-white">New service</h3>

      {/* Top sections */}
      <ul className="space-y-2 max-h-[40vh] overflow-y-auto scrollbar-thin border border-border rounded-lg mb-6">
        {sections.map((item) => (
          <li
            key={item.id}
            className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer
              ${
                selected === item.id
                  ? "bg-red-100 text-redlight font-medium"
                  : "hover:bg-gray-100 hover:text-redlight"
              }`}
            onClick={() => onSelect(item.id)}
          >
            <span>{item.label}</span>
            {item.badge && (
              <span className="text-xs bg-purple-600 text-white rounded-full px-2 py-0.5">
                {item.badge}
              </span>
            )}
          </li>
        ))}
      </ul>

      {/* Settings */}
      <h3 className="text-sm font-semibold mb-4 text-white">Settings</h3>
      <ul className="space-y-2 max-h-[30vh] overflow-y-auto scrollbar-thin border border-border rounded-lg">
        {settings.map((item) => (
          <li
            key={item.id}
            className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer
              ${
                selected === item.id
                  ? "bg-red-100 text-redlight font-medium"
                  : "hover:bg-gray-100 hover:text-redlight"
              }`}
            onClick={() => onSelect(item.id)}
          >
            <span>{item.label}</span>
            {item.badge && (
              <span className="text-xs bg-gray-800 text-white rounded-full px-2 py-0.5">
                {item.badge}
              </span>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default NewServiceSidebar;
